import { RouteTally } from './../../model/services/data-manager.service';
import { feature } from '@turf/helpers';
import { InterruptableTimer } from './../../model/interruptable-timer';
import { ReportCostsComponent } from './report-costs/report-costs.component';
import { RoutesChange } from './../../model/services/routes.service';
import { RoutesService } from 'app/model/services/routes.service';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { Route } from 'app/types/route-data';
import { AttributeTally } from 'app/model/mapping/drawing/RouteFeature';
import { ReportingService } from 'app/model/services/reporting.service';

export type ReportMode = 'costs' | 'supplemental' | 'summary';


export type SubMode = '<*>' | '*+' | '*';
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportsComponent implements OnInit {
  @ViewChild('costReport') costReport!: ReportCostsComponent;
  @ViewChild('supplReport') supplReport!: ReportCostsComponent;
  @ViewChild('summaryReport') summaryReport!: ReportCostsComponent;

  _refreshTimer: InterruptableTimer = new InterruptableTimer();
  _reportMode: ReportMode = 'costs';
  public set reportMode(mode: ReportMode) {
    this._reportMode = mode;
    this.reportModeChange.emit(mode);
    this.Refresh();
  }
  public get reportMode(): ReportMode {
    return this._reportMode;
  }
  @Output()
  public reportModeChange = new EventEmitter<ReportMode>;


  private _route?: Route;
  @Input()
  public set route(route: Route | undefined) {
    this._route = route;
    console.log(this._route);
    this.Refresh();
  }
  public get route(): Route | undefined {
    return this._route;
  }
  public get title(): string {
    let heading = 'Route ' + this._route?.name;
    const subMode = this._route?.expanded ? '*' : '*+';
    if (subMode === '*+') {
      heading += ' and its children';
    } else {
      heading += ' only';
    }
    return heading;
  }

  public get materialCost(): string {
    if (!!this._totals?.materials) {
      return '$' + Math.round(Number(this._totals.materials));
    }
    return '';

  }
  public get laborCost(): string {
    if (!!this._totals?.labor) {
      return '$' + Math.round(Number(this._totals.labor));
    }
    return '';
  }
  public get supplCost(): string {
    if (!this._totals?.supplemental) return '';
    return '$' + Math.round(Number(this._totals.supplemental));

    return '';
  }
  public get totalCost(): string {
    if (!!this._totals?.total) {
      return '$' + Math.round(Number(this._totals.total));
    }
    return '';
  }


  private _ready: boolean = false;
  constructor(private cdr: ChangeDetectorRef, private rpts: ReportingService) { }

  ngOnInit(): void {
    this._ready = true;
    this.rpts.SetReportsComponent(this);
    RoutesService.onChange.subscribe((changeInfo: RoutesChange) => {
      if (changeInfo.change === 'route-change') {
        this.Refresh();
      }
    });
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  RefreshAll() {
    this._refreshTimer.Start(() => {
      this._totals = undefined;
      this.summaryReport.Refresh();
      // this.supplReport.Refresh();
      this.costReport.Refresh();
    }, 1000);
  }
  SelectReport(report: ReportMode) {
    this.reportMode = report;

  }
  private _totals?: { [key: string]: number };

  SetTally(tally: RouteTally) {
    let totals = {
      labor: 0,
      materials: 0,
      length: 0,
      total: 0
    };

    for (let key in tally) {
      if (!tally.hasOwnProperty(key)) continue;
      const entry = tally[key];
      if (!entry) continue;
      totals.labor += (!!entry.costs.labor) ? entry.costs.labor : 0;
      totals.materials += (!!entry.costs.materials) ? entry.costs.materials : 0;

    }
    totals.total += totals.labor + totals.materials;


    this._totals = totals;
    this.cdr.markForCheck();
    this.Refresh();
  }
}
